import { render, staticRenderFns } from "./SalaryCertificate.vue?vue&type=template&id=f99999ec&"
import script from "./SalaryCertificate.vue?vue&type=script&lang=js&"
export * from "./SalaryCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports